<template>
    <div class="renderPage">
        <v-tabs background-color="primary" icons-and-text fixed-tabs center-active v-model="tab2">
            <v-tabs-slider></v-tabs-slider>
            <v-tab key="ingreso_registrados" @click="limpiar()">
                Salidas Registradas
                <v-icon>mdi-content-save</v-icon>
            </v-tab>
            <v-tab key="ingreso_nuevos" @click="limpiar()">
                Nueva Salida
                <v-icon>mdi-pencil-box</v-icon>
            </v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab2" class="ti">
            <v-tab-item key="ingreso_registrados">
                <v-spacer></v-spacer>
                <v-card>
                    <v-col cols="12" sm="12" md="12"> </v-col>
                    <v-form ref="form" v-model="valid">
                        <v-row>
                            <v-col cols="12" sm="4" md="4">
                                <v-dialog ref="dialog" v-model="dateModal" :return-value.sync="dates" persistent
                                    width="290px">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field v-model="datesFormat" label="Rango de fechas"
                                            prepend-icon="mdi-calendar" readonly required :rules="dateRules"
                                            v-bind="attrs" v-on="on" class="pa-0" outlined dense></v-text-field>
                                    </template>
                                    <v-date-picker v-model="dates" range @click="setDatesFormat()">
                                        <v-spacer></v-spacer>
                                        <v-btn text color="primary" @click="dateModal = false">
                                            Cancel
                                        </v-btn>
                                        <v-btn text color="primary" @click="
                                            $refs.dialog.save(dates);
                                        setDatesFormat();
                                        ">
                                            OK
                                        </v-btn>
                                    </v-date-picker>
                                </v-dialog>
                            </v-col>

                            <v-col cols="12" sm="2" md="2">
                                <v-btn color="primary" @click="getData()" :disabled="!valid">
                                    <v-icon left> mdi-file-find </v-icon>
                                    Buscar
                                </v-btn>
                            </v-col>

                            <v-col cols="12" sm="6" md="6">
                                <v-text-field v-model="search" append-icon="mdi-magnify" label="Filtrar resultados"
                                    single-line hide-details outlined dense></v-text-field>
                            </v-col>
                        </v-row>
                    </v-form>
                    <v-data-table :headers="headers" :items="items" :search="search">
                        <template v-slot:top> </template>
                        <template v-slot:[`item.actions`]="{ item }">
                            <v-icon small class="mr-2" @click="editItem(item)">
                                mdi-pencil
                            </v-icon>
                        </template>
                        <template v-slot:no-data>
                            <v-btn color="primary" @click="getData()"> Refrescar </v-btn>
                        </template></v-data-table>
                </v-card>
            </v-tab-item>
            <v-tab-item key="ingreso_nuevos">
                <v-form v-model="valid">
                    <v-container>
                        <v-row>

                            <v-col col="12" md="4" sm="4">
                                <v-select label="Usuarios" item-text="nombre" item-value="cedula"
                                    v-model="editedItem.idUsuario" :items="usuarios" :disabled="!validUsuarios"
                                    class="pa-0"></v-select>
                            </v-col>

                            <v-col cols="12" sm="3" md="3">
                                <v-text-field v-model="editedItem.monto" type="number" label="Monto" step="any" min="0"
                                    required class="pa-0" :disabled="incluirValid" outlined dense></v-text-field>
                            </v-col>

                            <v-col cols="12" sm="3" md="3">
                                <v-text-field type="text" v-model="fecha" label="Fecha" class="pa-0" readonly outlined
                                    dense></v-text-field>
                            </v-col>

                            <v-col cols="12" sm="6" md="6">
                                <v-text-field v-model="editedItem.descripcion" label="Descripción" :rules="nameRules"
                                    required class="pa-0" :disabled="incluirValid" outlined dense></v-text-field>
                            </v-col>
                        </v-row>
                    </v-container>
                    <div>
                        <v-expansion-panels multiple v-model="panel"> </v-expansion-panels>
                    </div>

                    <v-container>
                        <v-row align="center" justify="space-around"> </v-row>
                    </v-container>

                    <v-row align="center" justify="space-around">
                        <v-btn color="primary" :disabled="!incluirValid" @click="incluir()">
                            Incluir
                        </v-btn>
                        <v-btn color="primary" :disabled="!guardarValid" @click="save()">
                            Guardar
                        </v-btn>
                        <v-btn color="primary" :disabled="!cancelarValid" @click="cerrar()">
                            Cancelar
                        </v-btn>
                    </v-row>
                    <v-container>
                        <v-row align="center" justify="space-around"> </v-row>
                    </v-container>
                </v-form>
            </v-tab-item>
            <Snackbar v-bind:text="snackText" v-bind:snackbar.sync="snackValue" />
        </v-tabs-items>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";
import Snackbar from "./shared/Snackbar.vue";

export default {
    components: {
        Snackbar,
    },
    // dark: true,
    data() {
        return {
            btnAgregarArti: false,
            iconVisible: false,
            iconVisibleCedula: false,
            visibleBtnConsultar: true,
            visibleProgress: false,
            dialog: false,
            dialogArticulos: false,
            valid: false,
            incluirValid: true,
            consultarEstadoValid: false,
            cancelarValid: false,
            reenviarValid: false,
            imprimirValid: false,
            guardarValid: false,
            tab2: 1,
            search: "",
            snackText: "",
            snackValue: false,
            dialogDelete: false,
            dateModal: false,
            dates: [],
            datesFormat: [],
            panel: [],
            headers: [
                {
                    text: "Código",
                    align: "start",
                    value: "id",
                },
                {
                    text: "Monto",
                    align: "start",
                    value: "monto",
                },
                {
                    text: "Descripción",
                    align: "start",
                    value: "descripcion",
                },
                {
                    text: "Vendedor",
                    align: "start",
                    value: "vendedor",
                },
                {
                    text: "Fecha",
                    align: "start",
                    value: "fecha",
                },
                { text: "Editar", value: "actions", width: 50, sortable: false },
            ],
            items: [],
            usuarios: [],
            comprobante: [],
            editedIndex: -1,
            fecha: new Date().toISOString().slice(0, 10),
            reporte: {
                cedula: "",
                fechaInicio: new Date().toLocaleString("en-US", { timeZone: "America/Costa_Rica" }),
                fechaFin: new Date().toLocaleString("en-US", { timeZone: "America/Costa_Rica" }),
            },
            editedItem: {
                id: 0,
                companyId: "",
                idUsuario: "",
                fecha: new Date().toISOString().slice(0, 10),
                monto: 0,
                tipo: 2,
                descripcion: "",
            },
            defaultItem: {
                id: 0,
                companyId: "",
                idUsuario: "",
                fecha: new Date().toISOString().slice(0, 10),
                monto: 0,
                tipo: 2,
                descripcion: "",
            },
            opcionesSistemaCia: [],
            showNewData: false,
            showNewDataArti: false,
            nameRules: [(v) => !!v || "Campo requerido"],
            tempFile: "",
            modelFile: null,
        };
    },

    computed: {
        ...mapGetters(["user", "strCia"]),
    },

    watch: {
        dialog(val) {
            val || this.close();
        },

        dialogArticulos(val) {
            val || this.close();
        },

        search() {
            this.snackValue = false;
        },
    },

    created() {
        this.reporte.cedula = this.user.cedula;
        this.setDates();
        this.getData();
        this.getUsuariosPorCia();
    },

    methods: {
        signalChange: function (evt) {
            this.snackText = "Si llega al escribir" + evt;
            this.snackValue = true;
        },

        getData() {
            let me = this;
            axios
                .get(
                    "api/Tiempos/GetSaldoMovimientos?companyId=" +
                    this.strCia +
                    "&tipo=2" +
                    "&fechaInicio=" +
                    this.dates[0].toString() +
                    "&fechaFin=" +
                    this.dates[1].toString(),
                    {
                        crossdomain: true,
                    }
                )
                .then(function (response) {
                    me.items = response.data;
                })
                .catch(function (error) {
                    console.log(error);
                });
        },

        printDate: function () {
            return new Date().tolocal;
        },

        setDates() {
            var date = new Date();
            //var dateInicio = new Date(date.getFullYear(), date.getMonth(), 1);
            var dateInicio = new Date(date.getFullYear(), date.getMonth(), 1);
            //var dateFinal = new Date(date.getFullYear(), date.getMonth() + 1, 0);
            this.dates[0] = dateInicio.toISOString().substr(0, 10);
            this.dates[1] = date.toISOString().substr(0, 10);

            var year = date.getFullYear();
            var month = date.getMonth() + 1;
            var dt = date.getDate();

            if (dt < 10) {
                dt = "0" + dt;
            }
            if (month < 10) {
                month = "0" + month;
            }

            var yearInicio = dateInicio.getFullYear();
            var monthInicio = dateInicio.getMonth() + 1;
            var dtInicio = dateInicio.getDate();

            if (dtInicio < 10) {
                dtInicio = "0" + dtInicio;
            }
            if (monthInicio < 10) {
                monthInicio = "0" + monthInicio;
            }

            this.datesFormat[0] = dtInicio + "-" + monthInicio + "-" + yearInicio;
            this.datesFormat[1] = dt + "-" + month + "-" + year;
        },

        editItem(item) {
            this.snackValue = false;
            this.editedIndex = this.items.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.getModeloComprobante();
            this.tab2 = 1;
            this.cancelarValid = false;
            this.guardarValid = false;
            this.incluirValid = true;
        },

        detalleEditItem(item) {
            if (this.guardarValid) {
                this.detalleEditedIndex = this.lineasDetalle.indexOf(item);
                this.detalleEditedItem = Object.assign({}, item);
                this.dialogArticulos = true;
            }
        },

        closeDelete() {
            this.dialogDelete = false;
            this.$nextTick(() => {
                this.detalleEditedItem = Object.assign({}, this.detalleDefaultItem);
                this.detalleEditedIndex = -1;
            });
        },

        deleteItemConfirm() {
            if (this.guardarValid) {
                this.lineasDetalle.splice(this.detalleEditedIndex, 1);
                this.closeDelete();
            }
        },

        getModeloComprobante() {
            this.snackValue = false;
            let me = this;

            axios
                .get(
                    "api/Tiempos/GetSaldoMovimientoById?companyId=" +
                    this.strCia +
                    "&id=" +
                    this.editedItem.id
                )
                .then(function (response) {
                    me.editedItem = response.data;
                    me.fecha = me.editedItem.fecha;
                })
                .catch(function (error) {
                    console.log(error);
                });
        },

        getUsuariosPorCia() {
            let me = this;
            axios
                .get(
                    "api/Usuarios/getUsuariosPorCia?companyId=" +
                    this.strCia + "&usuarioId=" +
                    this.user.id,
                )
                .then(function (response) {
                    me.usuarios = response.data;
                    console.log(me.user.cedula);
                    const myUser = me.usuarios.find(user => user.cedula === me.user.cedula);
                    console.log(myUser.tipo);
                    if (myUser.tipo === true) {
                        me.reporte.cedula = "0";
                        me.validUsuarios = true;
                    } else {
                        me.reporte.cedula = myUser.cedula;
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
        },

        save() {
            this.snackValue = false;

            let me = this;
            this.visibleProgress = true;
            this.editedItem.fecha = new Date();
            this.editedItem.companyId = this.strCia;

            axios
                .post("api/Tiempos/InsertSaldoMovimientos", this.editedItem)
                .then(function () {
                    me.getData();
                    me.snackText = "Se registro la salida satisfactoriamente";
                    me.snackValue = true;
                })
                .catch(function (error) {
                    console.log(error);
                    me.snackText = "Ocurrio un error inesperado";
                    me.snackValue = true;
                });

            this.cancelarValid = false;
            this.guardarValid = false;
            this.incluirValid = true;
            this.snackValue = false;
        },

        close() {
            this.snackValue = false;
            this.dialogArticulos = false;
            this.$nextTick(() => {
                this.detalleEditedItem = Object.assign({}, this.detalleDefaultItem);
                this.detalleEditedIndex = -1;
            });
        },

        closed() {
            this.snackValue = false;
            this.showNewDataArti = false;
            this.dialog = false;
            this.dialogArticulos = false;
            this.dialogBuscarArticulos = false;
        },

        limpiar() {
            this.snackValue = false;
        },

        cerrar() {
            this.snackValue = false;
            this.dialog = false;
            this.dialogArticulos = false;
            this.$nextTick(() => {
                this.editedIndex = -1;
                this.editedItem = Object.assign({}, this.defaultItem);
                this.valid = false;
                this.cancelarValid = false;
                this.guardarValid = false;
                this.incluirValid = true;
                this.detalleEditedItem = Object.assign({}, this.detalleDefaultItem);
                this.lineasDetalle = [];
                this.btnAgregarArti = false;
            });
        },

        getFechaActual() {
            let me = this;
            axios
                .get("api/Facturacion/getFechaActualString")
                .then(function (response) {
                    me.fecha = response.data;
                })
                .catch(function (error) {
                    console.log(error);
                });
        },

        incluir() {
            this.snackValue = false;
            this.$nextTick(() => {
                this.editedIndex = -1;
                this.editedItem = Object.assign({}, this.defaultItem);
                this.cancelarValid = true;
                this.guardarValid = true;
                this.incluirValid = false;
            });
        },
    },
};
</script>

<style>
.cd {
    overflow: scroll;
}

.v-tabs-items {
    overflow: auto;
}

.botonSalir {
    position: fixed;
    top: 5px;
    right: 5px;
}

.right-input input {
    text-align: right;
}
</style>